import { type MouseEvent } from 'react';

import PillButtonContainer from 'components/buttons/PillButtonContainer';
import CloseIcon from 'components/icons/CloseIcon';
import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EntitySelectPillButton: FunctionComponent<Props> = ({
    className = '',
    hasValue = false,
    onClick,
    onRemove,
    testId = TEST_ID,
    text
}) => {
    const selectedClass = hasValue ? styles.selected : '';

    const handleOnclick = () => {
        onClick?.();
    };

    const handleRemove = (event: MouseEvent) => {
        event.stopPropagation();
        onRemove?.();
    };

    return (
        <PillButtonContainer
            className={`${selectedClass} ${styles.entitySelectPillButton} ${className}`}
            onClick={handleOnclick}
            testId={testId}>
            <BodyText className={`${selectedClass} ${styles.bodyText}`} text={text} />

            {hasValue && onRemove && (
                <span className={styles.removeButton} onClick={handleRemove}>
                    <CloseIcon className={styles.closeIcon} />
                </span>
            )}
        </PillButtonContainer>
    );
};

export default EntitySelectPillButton;
